import { InputBaseProps as MaterialInputBaseProps } from "@mui/material/InputBase";
import { ClassNameMap } from "@mui/styles";

import { InternalClasses } from "../helpers";

import { NonGenericBaseFormFieldProps } from "@/types/baseFormField";
import { InputVibe } from "@/types/mui";

export type BaseInputBaseClasses =
  | "root"
  | "disabled"
  | "error"
  | "focused"
  | "input"
  | "adornedStart"
  | "adornedEnd"
  | "inputAdornedStart"
  | "inputAdornedEnd"
  | "neutral"
  | "form"
  | "noPadding"
  | "medium"
  | "small"
  | "multiline";

export type BaseInputProps = Omit<
  MaterialInputBaseProps,
  "classes" | "color" | "variant" | "margin" | "fullWidth" | "name"
> &
  Omit<NonGenericBaseFormFieldProps, "errorMessage" | "label" | "rules"> & {
    classes?: Partial<ClassNameMap<BaseInputBaseClasses>>;
    vibe?: InputVibe;
    size?: "medium" | "small";
    noPadding?: boolean;
  };

export type BaseInputSsrProps = BaseInputProps & {
  forwardedRef?: React.Ref<HTMLInputElement>;
};

const PREFIX = "ZeffyInput";

export const zeffyInputClasses: InternalClasses<typeof PREFIX, BaseInputBaseClasses> = {
  root: `${PREFIX}-root`,
  neutral: `${PREFIX}-neutral`,
  form: `${PREFIX}-form`,
  input: `${PREFIX}-input`,
  multiline: `${PREFIX}-multiline`,
  error: `${PREFIX}-error`,
  focused: `${PREFIX}-focused`,
  medium: `${PREFIX}-medium`,
  small: `${PREFIX}-small`,
  disabled: `${PREFIX}-disabled`,
  adornedStart: `${PREFIX}-adornedStart`,
  adornedEnd: `${PREFIX}-adornedEnd`,
  inputAdornedStart: `${PREFIX}-inputAdornedStart`,
  inputAdornedEnd: `${PREFIX}-inputAdornedEnd`,
  noPadding: `${PREFIX}-noPadding`,
};
